module.exports = __webpack_public_path__ + "img/omni-channel.41e0b52f.png";